export const siteSettings = {
  name: "Infinite Trade Forge Markets",
  link: "https://infinitetradeforgemarkets.com",
  email: "support@infinitetradeforgemarkets.com",
  appLink: "https://app.infinitetradeforgemarkets.com",
};
